export const formatMessage = (message: string | null | undefined) => {
  if (message == null) return ''

  const formatMessage = message
    .replace(/https:.*$/, '')
    .replace(/internal:.*$/, '')
  return formatMessage
}
